var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExploitsAndKevMonochrome = function SvgExploitsAndKevMonochrome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 57,
    fill: "none",
    viewBox: "0 0 56 57"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#454549",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8 24.41c0-2.87 0-4.307.437-5.574a8 8 0 0 1 1.848-2.99c.938-.957 2.222-1.6 4.79-2.884l7.2-3.6c2.1-1.05 3.149-1.574 4.25-1.78a8 8 0 0 1 2.95 0c1.101.206 2.15.73 4.25 1.78l7.2 3.6c2.568 1.284 3.852 1.927 4.79 2.885a8 8 0 0 1 1.848 2.989C48 20.103 48 21.539 48 24.41v8.178c0 2.872 0 4.308-.437 5.575a8 8 0 0 1-1.848 2.99c-.938.957-2.222 1.6-4.79 2.884l-7.2 3.6c-2.1 1.05-3.149 1.574-4.25 1.78a8 8 0 0 1-2.95 0c-1.101-.206-2.15-.73-4.25-1.78l-7.2-3.6c-2.568-1.284-3.852-1.926-4.79-2.884a8 8 0 0 1-1.848-2.99C8 36.897 8 35.461 8 32.59z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M28 19.167V28.5m0 9.333h.023"
  })));
};
export default SvgExploitsAndKevMonochrome;